<template>
  <!-- TicketDetailRight -->

  <div class="detail-right">
    <p class="right_1 show-more-ticket-right-field hover-shadow"
      title="管理员可通过 设置 > 界面组件 配置默认展示哪些内容"
      @click="showMoreTicketField">其他工单属性(已折叠,点击可展开)</p>

    <!-- 关联工单 父子工单 -->
    <LinkedTicketList :ticketNo="ticketEntity.orderId"/>

    <!-- 订单 -->
    <p class="RightMerchantOrder">
      <span>
        <a @click="goOrder" title="点击跳转到订单详情页"><b class="strong">订单</b></a>

        <a style="color:#5b7e94;font-size:12px;"
          @click="doCopyOrder"
          title="点击复制订单信息">复制</a>

        <a style="color:#5b7e94;font-size:12px;" @click="goRecruit" title="点击跳转到招募需求页">招募</a>
        <a style="color:#5b7e94;font-size:12px;" @click="goPeople" title="点击跳转到人员初筛页">人员</a>
        <a style="color:#5b7e94;font-size:12px;" @click="goStudy" title="点击跳转到培训计划页">培训</a>
      </span>
    </p>

    <p class="RightMerchantOrder">
      <MerchantOrderSearch
        ref="ticket_order_18"
        :css="'width:100%'"
        @change="updateMerchantOrderId"
        :id="ticketEntity.merchantOrderId"/>
    </p>

    <!-- 商家 -->
    <p class="RightMerchant"
      title="在框中输入名字可搜索并修改">
      <span class="strong">商家</span>

      <a style="color:#5b7e94;font-size:12px;"
        @click="doCopyMerchant"
        title="点击复制商家信息">复制</a>
    </p>
    <p class="RightMerchant">
      <MerchantSearch
        ref="ticket_MerchantSearch_24"
        :css="'width:100%'"
        @change="updateMerchantId"
        :id="ticketEntity.merchantId"/>
    </p>

    <!-- 店铺 -->
    <p class="RightShop"
      title="在框中输入名字可搜索并修改">
      <span class="strong">店铺</span>

      <a style="color:#5b7e94;font-size:12px;"
        @click="doCopyShop"
        title="点击复制店铺信息">复制</a>
    </p>
    <p class="RightShop">
      <TicketFormShop style="width:100%"
        ref="TicketFormShop_58"
        v-model="ticketEntity.shopId"
        @change="onShopChange"/>
    </p>

    <!-- 工时 -->
    <p>
      <el-popover width="450" placement="left" trigger="hover">
        <span>点击输入框, 然后点击其他位置, 以提交修改</span>

        <span slot="reference">
          <span class="strong">工时(小时)</span>
          <span style="font-size:10px;">?</span>
        </span>
      </el-popover>
    </p>
    <p>
      <el-input-number v-model="ticketEntity.workHour"
        placeholder="点我, 然后点其他地方, 以提交"
        :precision="1"
        :min="0"
        @blur="onWorkHourChange"/>
    </p>

    <!-- 开始时间 -->
    <p>
      <span class="strong">开始时间</span>
    </p>
    <p>
      <el-date-picker
        :picker-options="datePickerOptions"
        placeholder="工单开始时间"
        :popper-class="'popper_class_0'"
        style="width:100%;"
        v-model="ticketEntity.startAt"
        type="datetime"
        @change="onStartAtChange"/>
    </p>

    <!-- 截止时间 -->
    <p class="RightEndAt">
      <span class="strong">截止时间</span>
    </p>
    <p class="RightEndAt">
      <el-date-picker
        :picker-options="datePickerOptions"
        placeholder="工单截止时间"
        :popper-class="'popper_class_0'"
        style="width:100%;"
        v-model="ticketEntity.endAt"
        type="datetime"
        @change="onEndAtChange"/>
    </p>

    <p>
      <span class="strong">项目</span>
    </p>
    <p>
      <TicketProjectSelect style="width:100%;"
        :ticketNo="ticketEntity.orderId"
        @change="onTicketProjectChange"/>
    </p>

    <!-- 客服排班信息 -->
    <p class="RightCustomerSchedule">
      <span class="strong">客服(排班) 信息</span>
    </p>
    <CustomerScheduleInfo
      class="RightCustomerSchedule"
      :customerId="ticketEntity.creatorId"
      :scheduleTime="ticketEntity.createdAt"/>

    <!-- 语音呼叫信息 -->
    <p class="RightCallInfo">
      <span class="strong">语音呼叫信息</span>
    </p>
    <p class="RightCallInfo">
      <TicketWidgetCallInfo v-model="ticketEntity.callId"/>
    </p>

    <!-- 工作流 -->
    <p class="RightWorkflow">
      <span class="strong">工作流</span>
      <a title="查看工作流" target="_blank"
        :href="'/ticket/activiti_model_viewer?modelId=' + ticketEntity.workflowId + '&ticketNo=' + ticketEntity.orderId"
        style="float:right;margin-right:10px;">预览</a>
    </p>

    <p class="RightWorkflow">
      <TicketWorkflowSelect :value="ticketEntity.workflowId" />

      <WorkflowGraph
        ref="workflowGraph"
        v-if="ticketEntity.workflowId"
        :workflowId="ticketEntity.workflowId"
        :ticketNo="ticketEntity.orderId"/>
    </p>

    <!-- 自定义组件 -->
    <TicketWidgetGroup group="AfterTicketDetailRight"
      style="width:100%;"/>

    <!-- 撑高 -->
    <div style="height:50px;"/>
  </div>
</template>

<style>
  .show-more-ticket-right-field {
    cursor: pointer;
    padding: 5px;
    background:#FCFCFC;
    text-align:center;
  }

  .RightMerchantOrder, .RightMerchant, .RightEndAt, .RightCustomerSchedule, .RightCallInfo, .RightWorkflow, .RightShop {
    display: none;
  }

  .popper_class_0 {
    margin-left: -150px;
  }

  .popper_class_0 .popper__arrow {
    left : 300px!important;
  }
</style>

<script>
// TicketDetailRight
import moment from 'moment';

export default {
  name: "TicketDetailRight",

  props: ['ticket', 'value'], // 用于传入值

  watch : {
    ticket() {
      console.log('#184 TicketDetailRight watch ticket', this.value, this.ticket, this.ticketEntity);

      this.ticketEntity = Object.assign({}, this.ticket);
    },

    value() {
      console.log('#188 TicketDetailRight watch value', this.value, this.ticket, this.ticketEntity);

      this.ticketEntity = this.value;
    }
  },

  created() {
    // console.log('#204 created TicketDetailLeft', this.ticket, this.value);
  },

  mounted() {
    // console.log('#208 mounted TicketDetailLeft', this.ticket, this.value);

    if ( !!this.value ) {
      this.ticketEntity = this.value;
    }
  },

  data() {
    return {
      datePickerOptions: {
        shortcuts: [
          {
            text: '现在',
            onClick(vm) {
              vm.$emit('pick', moment().toDate())
            }
          },
          {
            text: '今天9点',
            onClick(vm) {
              vm.$emit('pick', moment().hour(9).startOf('hour').toDate()) // subtract(8, 'hours')
            }
          },
          {
            text: '今天12点',
            onClick(vm) {
              vm.$emit('pick', moment().hour(12).startOf('hour').toDate())
            }
          },
          {
            text: '今天14点',
            onClick(vm) {
              vm.$emit('pick', moment().hour(14).startOf('hour').toDate())
            }
          },
          {
            text: '今天18点',
            onClick(vm) {
              vm.$emit('pick', moment().hour(18).startOf('hour').toDate())
            }
          },
          {
            text: '明天9点',
            onClick(vm) {
              vm.$emit('pick', moment().add(1, 'days').hour(9).startOf('hour').toDate())
            }
          },
          {
            text: '明天12点',
            onClick(vm) {
              vm.$emit('pick', moment().add(1, 'days').hour(12).startOf('hour').toDate())
            }
          },
          {
            text: '明天18点',
            onClick(vm) {
              vm.$emit('pick', moment().add(1, 'days').hour(18).startOf('hour').toDate())
            }
          },
          {
            text: '后天9点',
            onClick(vm) {
              vm.$emit('pick', moment().add(2, 'days').hour(9).startOf('hour').toDate())
            }
          },
          {
            text: '后天18点',
            onClick(vm) {
              vm.$emit('pick', moment().add(2, 'days').hour(18).startOf('hour').toDate())
            }
          },
          {
            text: '一周后',
            onClick(vm) {
              vm.$emit('pick', moment().add(1, 'weeks').toDate())
            }
          },
          {
            text: '两周后',
            onClick(vm) {
              vm.$emit('pick', moment().add(2, 'weeks').toDate())
            }
          }
        ]
      },

      ticketEntity : {}
    }
  },

  methods: {
    showMoreTicketField() {
      $('.RightMerchantOrder').slideDown();
      $('.RightMerchant').slideDown();
      $('.RightShop').slideDown();
      $('.RightEndAt').slideDown();
      $('.RightCustomerSchedule').slideDown();
      $('.RightWorkflow').slideDown();
      $('.RightCallInfo').slideDown();

      $('.right_1').slideUp(); // 隐藏自己
    },

    doCopyMerchant() {
      var merchant = this.$refs.ticket_MerchantSearch_24.merchant;
      var txt = merchant.name + "(" + merchant.code + ")";
      this.writeToClipboard( txt );

      _message('已复制到剪贴板 ' + txt);
    },

    doCopyShop() {
      var shop = this.$refs.TicketFormShop_58.shop;
      var txt = shop.name + "(" + shop.id + ")";
      this.writeToClipboard( txt );

      _message('已复制到剪贴板 ' + txt);
    },

    doCopyOrder() {
      var order = this.$refs.ticket_order_18.order;

      var txt = order.code + "(" + order.id + ")";
      this.writeToClipboard( txt );

      _message('已复制到剪贴板 ' + txt);
    },

    onDealUserChange() {
      this.ticket.workflowId = null;
    },

    initGraph() {
      this.$refs.workflowGraph.initGraph();
    },

    initGraph_if_has(_workflowId) {
      if ( this.$refs.workflowGraph ) {
        this.$refs.workflowGraph.initGraph_2(_workflowId);
      }
    },

    onShopChange( _shop ) {
      // console.log('#211 onShopChange', _shop );

      var _this = this;

      if ( !!this.value ) { // 新建
        this.ticketEntity.shopId = _shop ? _shop.id : null;
        this.$emit('input', this.ticketEntity);
        return;
      }

      sdk.TicketApi().updateShopId({
        no :  _this.ticket.orderId,
        shopId : _shop ? _shop.id : null
      }).then(() => {
        _message( '修改工单关联店铺成功' );
        _this.$emit('change', null);
      });
    },

    onTicketProjectChange(_projectIds) {
      var _this = this;

      if ( !_this.ticket || !_this.ticket.orderId ) {
        console.log('#258 onTicketProjectChange, no orderId', _this.ticket);
        return;
      }

      sdk.ProjectTicketApi().updateTicketProjectId({
        no: _this.ticket.orderId,
        projectIds: _projectIds
      }).then(res => {
        _message( '修改工单关联项目成功' );
        _this.$emit('change', null);
      });
    },

    onWorkHourChange() {
      console.log('#290 onWorkHourChange, ticketEntity=', this.ticketEntity, 'ticket=', this.ticket);

      // 新建页 
      if ( !this.ticket ) {
        this.$emit('input', this.ticketEntity);
        return;
      }

      if ( '' + this.ticketEntity.workHour == '' + this.ticket.workHour ) {
        console.log( '#383 工单工时的值没有变化' );
        return; // 没有变
      }

      if ( !confirm('确定要修改工时为 ' + this.ticketEntity.workHour + '?') ) {
        return;
      }

      var _this = this;

      if ( !!this.value ) { // 新建
        this.$emit('input', this.ticketEntity);
        return;
      }

      sdk.TicketApi().updateWorkHour({
        ticketNo :  _this.ticket.orderId,
        workHour : _this.ticketEntity.workHour
      }).then(() => {
        _message( '修改工时 成功' );

        _this.$emit('change', null);
      });
    },

    onStartAtChange() {
      var _this = this;

      if ( !!this.value ) { // 新建
        this.$emit('input', this.ticketEntity);
        return;
      }

      if ( !confirm('确定要修改开始时间为 ' + moment(_this.ticketEntity.startAt).format('YYYY-MM-DD HH:mm:ss') + '?') ) {
        return;
      }

      // 不太清楚为啥 这里就要 +8 创建时就不用
      var _startAtTime = _this.ticketEntity.startAt.getTime() + ( 8 * 60 * 60 * 1000 );
      var _startAt = new Date(_startAtTime);

      sdk.TicketApi().updateStartAt({
        no :  _this.ticket.orderId,
        startAt : _startAt
      }).then(() => {
        _message( '修改工单开始时间 成功' );
        _this.$emit('change', null);
      });
    },

    onEndAtChange() {
      var _this = this;

      if ( !!this.value ) { // 新建
        this.$emit('input', this.ticketEntity);
        return;
      }

      if ( !confirm('确定要修改截止时间为 ' + moment(_this.ticketEntity.endAt).format('YYYY-MM-DD HH:mm:ss') + ' ?') ) {
        return;
      }

      // 不太清楚为啥 这里就要 +8 创建时就不用
      var _endAtTime = _this.ticketEntity.endAt.getTime() + ( 8 * 60 * 60 * 1000 );
      var _endAt = new Date(_endAtTime);

      sdk.TicketApi().updateEndAt({
        no :  _this.ticket.orderId,
        endAt : _endAt
      }).then(() => {
        _message( '修改工单截止时间 成功' );
        _this.$emit('change', null);
      });
    },

    updateMerchantId(e) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.merchantId = e.id;
        this.$emit('input', this.ticketEntity);
        return;
      }

      var _this = this;
      sdk.TicketApi().updateMerchantId({
        no :  _this.ticket.orderId,
        merchantId : e.id
      }).then(()=>{
        _message( '修改工单关联商家 成功' );
        _this.$emit('change', null);
      });
    },

    updateMerchantOrderId(e) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.merchantOrderId = e.id;
        this.$emit('input', this.ticketEntity);
        return;
      }

      var _this = this;
      sdk.TicketApi().updateMerchantOrderId({
        no :  _this.ticket.orderId,
        merchantOrderId : e.id
      }).then(() => {
        _message('修改工单关联订单 成功' );
        _this.$emit('change', null);
      });
    },

    goOrder() {
      if ( !this.ticket ) {
        _message("#181 没有工单/订单信息");
        return;
      }

      if ( !this.ticket.merchantOrderId ) {
        _message("#186 工单" + this.ticket.orderId + "没有关联订单");
        return;
      }

      var _url = '/order/orderManage/detail?id=' + this.ticket.merchantOrderId;
      console.log("#334 goOrder, _url=" + _url);
      window.open(_url);
    },

    goRecruit() {
      if ( !this.ticket ) {
        _message("#197 没有工单/订单信息");
        return;
      }

      if ( !this.ticket.merchantOrderId ) {
        _message("#202 工单" + this.ticket.orderId + "没有关联订单");
        return;
      }

      var _url = '/order/orderManage/orderRecruitment?orderId=' + this.ticket.merchantOrderId;
      console.log("#338 goRecruit, _url=" + _url);
      window.open(_url);
    },

    goPeople() {
      if ( !this.ticket ) {
        _message("#213 没有工单/订单信息");
        return;
      }

      var _url = '/studyManage/primePeople?orderId=' + this.ticket.orderId;
      console.log("#346 goPeople, _url=" + _url);
      window.open(_url);
    },

    goStudy() {
      if ( !this.ticket ) {
        _message("#224 没有工单/订单信息");
        return;
      }

      var _url = '/studyManage/studyPlan?id=' + this.ticket.orderId;
      console.log("#352 goStudy, _url=" + _url);
      window.open(_url);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketDetailRight.vue